/*
 * @Author: stevensh
 * @Date: 2020-03-03 14:51:55
 * @Last Modified by: stevensh
 * @Last Modified time: 2020-03-03 15:14:28
 */
export function setStorage(key: string, val?: any): void {
  localStorage.setItem(key, JSON.stringify(val));
}

export function getStorage(key: string): any {
  return JSON.parse(localStorage.getItem(key));
}

export function removeStorage(key: string): void {
  localStorage.removeItem(key);
}
